"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMerge = void 0;
/**
 * Deep merge two objects.
 * @param {T} target The source object to be merged
 * @param {DeepPartial<T>} ...sources The values with the overrides
 * @returns {T} A new instance with the merged values
 */
const deepMerge = (target, ...sources) => {
    if (!sources.length) {
        return target;
    }
    const merged = Object.assign({}, target);
    for (const source of sources) {
        if (!source) {
            continue;
        }
        const keys = Object.keys(source);
        for (const key of keys) {
            if (!(source[key] instanceof Array) && typeof source[key] === 'object' && typeof target[key] === 'object') {
                merged[key] = exports.deepMerge(target[key], source[key]);
            }
            else if (source[key] !== undefined) {
                ;
                merged[key] = source[key];
            }
        }
    }
    return merged;
};
exports.deepMerge = deepMerge;
//# sourceMappingURL=deep-merge.js.map